import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
const features = [{
  text: "Hours Saved Weekly"
}, {
  text: "Cost Reduction"
}, {
  text: "Faster Workflows"
}, {
  text: "Productivity Gains"
}, {
  text: "Error Reduction"
}, {
  text: "Better CX"
}];
export default function TheRoiOfAiIntegration() {
  return <section data-section-id="254951" id="the-roi-of-ai-integration" className="relative bg-background py-20 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] w-[60%] h-[150%] bg-chart-1/5 blur-[120px] transform -rotate-45"></div>
        <div className="absolute top-[30%] -right-[10%] w-[50%] h-[100%] bg-chart-2/5 blur-[150px] transform rotate-12"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {}
        <div className="flex justify-center mb-16 md:mb-24">
          <Link to="/HomePage" className="inline-block transition-transform hover:scale-105 duration-300">
            <img src="/img/ai_outcome_partners_logo.png" alt="AI Outcome Partners" className="h-12 sm:h-16 md:h-20 lg:h-24 w-auto object-contain" data-wvc-srcset="/img/ai_outcome_partners_logo.png-wvc-srcset" data-wvc-sizes="/img/ai_outcome_partners_logo.png-wvc-sizes" loading="lazy" />
          </Link>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-12 md:gap-y-20 gap-x-8 max-w-5xl mx-auto">
          {features.map((feature, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center gap-4 md:gap-6 group">
              <div className="text-chart-1 transition-transform duration-300 group-hover:scale-110 group-hover:text-chart-2 bg-accent p-4 rounded-lg shadow-sm">
                <Check className="size-12 md:size-16 lg:size-20 stroke-[3]" />
              </div>
              <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground font-default tracking-tight">
                {feature.text}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}